import React, { useState, useRef, useEffect } from "react";
import Loader from "./Loader";
import { Document, Page, pdfjs } from "react-pdf";
import ControlPanel from "./ControlPanel";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
import PropTypes from "prop-types";

const PDFDriver = (props) => {
    const prevPath = usePrevious(props.filePath);
  
    const [scale, setScale] = useState(1.0);
    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);
    const [isLoading, setIsLoading] = useState(true);
    const [rotateAngle, setRotate] = useState(0);
    const [isPassProtected, showPassProtectedPdfText] = useState(false);
  
    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
        setIsLoading(false);
    }

    if(prevPath !== props.filePath && isPassProtected){
        showPassProtectedPdfText(false);
    }

    // Hook
    function usePrevious(value) {
        // The ref object is a generic container whose current property is mutable ...
        // ... and can hold any value, similar to an instance property on a class
        const ref = useRef();
        // Store current value in ref
        useEffect(() => {
            ref.current = value;
        }, [value]); // Only re-run if value changes
        // Return previous value (happens before update in useEffect above)
        return ref.current;
    }

    return (
        <div>
            {
                isPassProtected? null:<Loader isLoading={isLoading} />
            }
            <section
                id="pdf-section"
                className="d-flex flex-column align-items-center w-100"
                style={{width: "100%", maxHeight: "70vh", overflow: "scroll"}}
            >
                {
                    isPassProtected ? <p style={{fontSize: "18px", fontWeight: "bold", marginTop: "40%"}}>This file is password protected!</p>:<React.Fragment>
                        <ControlPanel
                            scale={scale}
                            setScale={setScale}
                            numPages={numPages}
                            pageNumber={pageNumber}
                            setPageNumber={setPageNumber}
                            file={props.filePath}
                            rotateAngle={rotateAngle}
                            setRotate={setRotate}
                        />
                        <Document
                            file={props.filePath}
                            onPassword={() => showPassProtectedPdfText(true)}
                            onLoadSuccess={onDocumentLoadSuccess}
                        >
                            <Page pageNumber={pageNumber} scale={scale} rotate={rotateAngle} />
                        </Document>   
                    </React.Fragment>
                }
            </section>
        </div>
    );
};

PDFDriver.propTypes = {
    filePath: PropTypes.any,
};


export default PDFDriver;
